import React, { CSSProperties, memo } from "react";

export const contentStyle = {
    contentHeader: {
        padding: "8px 0px",
        flexGrow: 1,
        backgroundColor: "#eee",
        color: 'black',
        textAlign: 'center',
        fontFamily: 'sans-serif'
    } as CSSProperties,
    io: {
        position: "relative",
        padding: "8px 24px",
        flexGrow: 1,
        color: 'black',
        fontFamily: 'sans-serif'
    } as CSSProperties,
    textLeft: { textAlign: "left", left: "-6px" } as CSSProperties,
    right: { right: "-10px" } as CSSProperties,
    textRight: { textAlign: "right" } as CSSProperties,
    handle: {
        width: 20,
        height: 20,
        margin: "auto",
        background: "#ddd",
        borderRadius: 10,
        border: '1px solid black',
        left: -5,
        boxShadow:
            "rgba(0, 0, 0, 0.2) 0px 1px 3px 0px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 2px 1px -1px"
    } as CSSProperties,
    handleRight: {
        width: 20,
        height: 20,
        margin: "auto",
        background: "#ddd",
        borderRadius: 10,
        right: '-5px',
        border: '1px solid black',        
        boxShadow:
            "rgba(0, 0, 0, 0.2) 0px 1px 3px 0px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 2px 1px -1px"
    } as CSSProperties,
    handleInvisible: {
        width: 20,
        height: 20,
        margin: "auto",
        background: "#ddd",
        borderRadius: 10,
        border: '1px solid black',
        left: -5,
        visibility: 'hidden',
        boxShadow:
            "rgba(0, 0, 0, 0.2) 0px 1px 3px 0px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 2px 1px -1px"
    } as CSSProperties,
    nextHandle: {
        width: 20,
        height: 20,
        margin: "auto",
        background: "#ddd",
        borderRadius: 10,
        border: '1px solid black',
        right: -5,
        boxShadow:
            "rgba(0, 0, 0, 0.2) 0px 1px 3px 0px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 2px 1px -1px"
    } as CSSProperties
};

const style = {
    body: {
        display: "flex",
        flexDirection: 'column',
        backgroundColor: "#fff",
        transition: "all 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        boxShadow: "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)",
        border: "0px solid #bbb",
        fontSize: 16,
        userSelect: 'none',
        pointerEvents: 'all',
        cursor: 'move',
        borderRadius: 5

    } as CSSProperties,
    selected: {
        boxShadow: "0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)"
    } as CSSProperties,
    title: {
        position: 'relative',
        padding: "8px 32px",
        flexGrow: 1,
        backgroundColor: "#eee",
        color: 'white',
        borderRadius: 5,
        fontFamily: 'sans-serif',
        fontSize: 24,
        fontWeight: 'bolder'
    } as CSSProperties,
    contentWrapper: {
        padding: "8px 0px"        
    } as CSSProperties
};

interface NodeProps {
    label: string;
    selected: boolean;
    color?: string;
    content: React.ReactNode;
    hideHeading?: boolean;
}

export type NodeInput = {
    label: string,
    type: 'imageNode' | 'questionNode' | 'answerNode',
    inputColor: string
}

export type NodeOutput = {
    label: string,
    type: 'imageNode' | 'questionNode' | 'answerNode',
    outputColor: string,
    singletons: string[]
}

const BaseNode: React.FC<NodeProps> = ({
    label,
    selected,
    color,
    content,
    hideHeading = false
}: NodeProps) => {
    let customTitle = { ...style.title };
    if (color) customTitle.backgroundColor = color;

    // Collapse contentWrapper on icon click    

    return (
        <div style={{ ...style.body, ...selected ? style.selected : undefined }}>
            {!hideHeading && <div style={customTitle}>{label}</div>}
            <div style={style.contentWrapper}>{content}</div>
        </div>
    );
};

export default memo(BaseNode);
